/**
 * Labstep
 *
 * @module services/prosemirror
 * @description Service for handling Prosemirror related functionalities
 */

import type { EditorState } from 'prosemirror-state';

export class ProsemirrorService {
  static transformDecorationState(
    state: any[],
    position = 0,
    depth = 1,
  ) {
    return state
      .filter((d, index) => (index + 1) % 3 === 0)
      .reduce((result, decoration, index) => {
        const localTransformedDecorations = decoration.local.map(
          (localDecoration) => {
            const { from, to } = localDecoration;
            const { comment } = localDecoration.type.spec;
            const startingPos = state[index * 3] + position + depth;
            return {
              from: from + startingPos,
              to: to + startingPos,
              ...comment,
            };
          },
        );

        const newPosition = state[index * 3] + position;
        const childrenTransformedDecorations =
          ProsemirrorService.transformDecorationState(
            decoration.children,
            newPosition,
            depth + 1,
          );
        return [
          ...result,
          ...localTransformedDecorations,
          ...childrenTransformedDecorations,
        ];
      }, []);
  }

  public static countNodesByType = (
    state: EditorState,
    targetName: string,
  ): number => {
    const { doc, schema } = state;
    let count = 0;

    doc.descendants((node) => {
      if (node.type === schema.nodes[targetName]) {
        count += 1;
      }
      return true;
    });

    return count;
  };
}
